import React, { Ref, useMemo, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { getCarouselConfig } from 'src/ui/common/molecules/carousel/config';
import { ICarousel } from 'src/ui/common/molecules/carousel/types';
import { debounce } from 'src/utils/helpers.utils';

export const Carousel: React.FC<ICarousel> = ({
    children,
    xl,
    noWheel = false,
    lg,
    md,
    sm,
    xs,
    className,
    ...settings
}) => {
    const sliderRef: Ref<Slider> = useRef(null);

    const onWheelSlider = debounce((e: any) => {
        if (!sliderRef.current) return;
        if (e.deltaX > 0 || e.deltaX < 0) {
            e.stopPropagation();
            e.preventDefault();
        }

        if (e.deltaX > 0) {
            sliderRef.current?.slickNext();
        }
        if (e.deltaX < 0) {
            sliderRef.current?.slickPrev();
        }
    }, 20);

    const config = useMemo(() => getCarouselConfig({ xs, xl, lg, md, sm, settings }), [lg, md, sm, xl, xs, settings]);

    return (
        <div className={className} onWheel={noWheel ? undefined : onWheelSlider}>
            <Slider {...config} vertical={false} ref={sliderRef}>
                {children}
            </Slider>
        </div>
    );
};